<template>
  <div class="analytics-dashboard-info">
    <slot />
  </div>
</template>

<style scoped>
.analytics-dashboard-info {
  position: relative;
  border: 1px solid #EFEFEF;
  border-radius: 10px;
  background-color: #FCFCFC;
  padding: 6px;
  overflow: hidden;
  font-size: 0.7rem;
}

</style>

<script>
export default {
  name: 'AnalyticsDashboardInfo',
  props: {
  }
}
</script>